export default __webpack_public_path__ + "static/media/finep.277ff3a4.svg";